define((require) => {
    "use strict";

    const Publishables      = require("ui/publish/Publishables");
    const Promise           = require("shared/util/Promise");
    const ChannelCollection = require("data/ChannelCollection");
    const LoggedInUserState = require("shared/ui/user/LoggedInUserState");
    const ChannelConfig     = require("ui/publish/channelSetup/ChannelConfig");
    const ContentQuery      = require("data/ContentQuery");
    const Channel           = require("ui/publish/channelSetup/Channel");

    return {

        /**
         * Provides channel configs for the company of the logged in user.
         * @return {Promise} promise that resolves with an object with the properties about publishables, channel config and channels information.
         */
        provide(options = {}) {
            const channelCollection = new ChannelCollection(options);
            const query = options.sorting || ContentQuery.sort().field("editedAt");
            const channelConfig = options.fetchChannelConfig && new ChannelConfig();
            const promises = [
                channelCollection.query(query),
                Channel.hasUnPushedChannels()
            ];

            if (channelConfig) {
                promises.push(channelConfig.fetch());
            }

            return Promise.all(promises)
                .then((results) => {
                    const companySettings = LoggedInUserState.get("companySettings");
                    const bundleStrategy = companySettings.get("bundleStrategy");
                    const channelConfigId = companySettings.get("channelConfigId");
                    const hasUnPushedChannels = results[1][0];

                    // Execute this fetch after channels. Having it executed in parallel may lead to unforeseen memory leaks in backend as channels and publishables are related to each other.
                    return Publishables.fetch(options)
                        .then((publishableOptions) => {
                            const {publishableCollection, publishableDescriptors} = publishableOptions;
                            return {
                                bundleStrategy,
                                channelConfigId,
                                channelCollection,
                                channelConfig,
                                publishableCollection,
                                publishableDescriptors,
                                hasUnPushedChannels
                            };
                        });
                });
        }
    };
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/editor/PublishOptionsProvider.js